import { mode } from '@chakra-ui/theme-tools';

export const globalStyles = {
	colors: {
		brand: {
			900: '#132068',
			700: '#3F51B5',
			600: '#4171E1'
		}
	},
	styles: {
		global: (props) => ({
			body: {
				bg: mode('brand.600', 'gray.900')(props),
				fontFamily: "'Roboto', sans-serif",
				//lineHeight: "0.8",
				fontSize: "12px"
				 
			},
			html: {
				fontFamily: "'Roboto', sans-serif",
				//lineHeight: "0.8"
			}
		})
	}
};
